import React from "react";
import { Link } from "react-router-dom";
import "../../styles/footer.css";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import FloatingLines from "../floatingLines/FloatingLines";


const footerContnet = [
  {
    title: "Company",
    links: [
      { name: "About Us", url: "/about" },
      { name: "Careers", url: "/careers" },
      { name: "Blog", url: "/blog" },
    ],
  },
  {
    title: "Support",
    links: [
      { name: "Help Center", url: "/help" },
      { name: "Contact Us", url: "/contact" },
      { name: "Privacy Policy", url: "/privacy" },
    ],
  },
  {
    title: "Resources",
    links: [
      { name: "Documentation", url: "/docs" },
      { name: "API Reference", url: "/api" },
      { name: "Community Forum", url: "/forum" },
    ],
  },
];
const Footer = () => {
  return (
    <footer className="footer section">
      <div className="footer__content">
        <div className="footer__hero">
          <FloatingLines
            enabledWaves={["top", "middle", "bottom"]}
            animationSpeed={1.20}
            interactive
            bendRadius={5}
            bendStrength={0}
            mouseDamping={0.05}
            parallax
            parallaxStrength={0.2}
          />

          <div className="footer__hero-content">
            <div className="footer__titles">
              <h2 className="footer__header">Start your trial today.</h2>
              <p className="footer__subs">
                Unlock the potential of your business with our next-level SaaS
                platform.
              </p>
              <p className="footer__subs">
                Transform your workflows and achieve new heights today.
              </p>
            </div>
            <div className="footer__btn">
              <Link to="/pricing" className="getStarted">
                Get Started
                <i class="bx  bx-chevron-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__content">
        <div className="footer__content-links">
          <div className="footer__socials">
            <h3 className="footer__section-title">TradeIQ</h3>
            <div className="footer__socials-icons">
              <a
                href="https://www.tradeiq.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter className="social-icon" />
              </a>
              <a
                href="https://www.instagram.com/izoneafrica?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="social-icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/tradeiq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn className="social-icon" />
              </a>
              <a
                href="https://www.facebook.com/tradeiq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF className="social-icon" />
              </a>
            </div>
          </div>
          <div className="footer__links grid">
            {footerContnet.map((section, index) => (
              <div key={index} className="footer__section">
                <h3 className="footer__section-title">{section.title}</h3>
                <ul className="footer__section-links">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex} className="footer__link-item">
                      <Link to={link.url} className="footer__link">
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="footer__content">
        <div className="footer__rights grid">
          <div className="footer__copy">
            <i className="uil uil-copyright footer__copy-icon"></i> 2026
            TradeIQ. All rights reserved.
          </div>
          <div className="footer__terms">
            <Link to="/terms" className="footer__terms-link">
              Terms & Conditions
            </Link>
          </div>
          <div className="footer__status">
            <span className="status__dot online"></span>
            Online
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
